import * as yup from "yup";
import { EmailType } from "models/automation";
import { SelectEmailTargetValue } from "./models";

export const schema = yup.object().shape({
  emailTargetType: yup.mixed<SelectEmailTargetValue>().required(),
  userId: yup.string().when("emailTargetType", {
    is: "user",
    then: (s) => s.required().label("User"),
    otherwise: (s) => s.notRequired(),
  }),
  onboardingJourneyNetworkRelationId: yup.string().when("emailTargetType", {
    is: "relation",
    then: (s) => s.required().label("Role"),
    otherwise: (s) => s.notRequired(),
  }),
  customEmail: yup
    .string()
    .email()
    .when("emailTargetType", {
      is: "custom",
      then: (s) => s.required().label("Email"),
    }),
  emailType: yup.mixed<EmailType>().when("emailTargetType", {
    is: (s: SelectEmailTargetValue) => s !== "custom",
    then: (s) => s.required().label("Email Type"),
    otherwise: (s) => s.notRequired(),
  }),
});

export type Schema = yup.InferType<typeof schema>;
